import {useEffect, useState} from "react";

const useRulesState = (checkRules) => {
  const [rulesInfo, setRulesInfo] = useState([]);

  const deleteRuleFromState = (ruleId) => {
    const newRules = rulesInfo.filter((rule) => rule.id !== ruleId);
    setRulesInfo([...newRules]);
  };

  const updateRuleFromState = (updatedRuleData, ruleId) => {
    const newRules = [...rulesInfo];

    const ruleIndex = newRules.findIndex((rule) => rule.id === ruleId);
    newRules[ruleIndex] = {
      ...updatedRuleData,
    };

    setRulesInfo([...newRules]);
  };

  useEffect(() => {
    if (checkRules) {
      setRulesInfo([...checkRules]);
    }
  }, [checkRules]);

  return {
    rulesInfo,
    deleteRuleFromState,
    updateRuleFromState
  };
};

export default useRulesState;